/**
 * The tower (law of total probability) tolerance a trigger's conditionals must meet against
 * its headline: ±0.02, the forecaster's coherence gate. The client derive check and the
 * user-trigger scorer both use it, and `towerTolerance.parity.test.js` pins it to the
 * server's derive route (`server/lib/deriveBranch.js` TOWER_TOLERANCE), so the client never
 * offers a derivation the server refuses.
 */
export const TOWER_TOLERANCE = 0.02;
